export default "__VITE_ASSET__DXHlL97k__"